import React, { useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Button, Input, Typography } from '@lyearn/ui';
import { Body, DialogComponent, Footer, Header } from '@/components/DialogComponent';

import { EditableTextProps } from './types';
import useEditableTextProps from './useEditableTextProps';

const EditbaleTextMobile: React.FC<EditableTextProps> = (props) => {
  const { name, onAction, mobileHeading, MobilePlaceholder } = props;

  const { t } = useTranslation();

  const [newName, setNewName] = useState(name);
  const [, setInputRef] = useState<HTMLDivElement | null>(null);

  const { onChange, onKeyUp, saveName } = useEditableTextProps(name, onAction, setNewName);

  const onCancel = () => {
    setNewName(name);
    onAction(name, name.trim());
  };

  return (
    <>
      <DialogComponent open renderAs="dialog" showCloseIcon={false} onClose={onCancel}>
        <Header className="heading-xs mb-16 justify-center">{mobileHeading}</Header>
        <Body>
          <Typography className="mb-8 ms-8" variant="body-short-02">
            {t('Common:Name')}
          </Typography>
          <Input
            ref={setInputRef}
            className="w-full"
            value={newName}
            onChange={onChange}
            onKeyUp={(e) => onKeyUp(e, newName)}
          />
        </Body>
        <Footer>
          <Button
            appearance="secondary"
            className="flex-grow me-8"
            variant="outlined"
            onClick={onCancel}>
            {t('Common:Cancel')}
          </Button>
          <Button className="flex-grow" onClick={() => saveName(newName)}>
            {t('Common:Rename')}
          </Button>
        </Footer>
      </DialogComponent>
      {MobilePlaceholder}
    </>
  );
};

export default EditbaleTextMobile;
